import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CampoPersonalizadoItem } from 'src/app/models/campo-personalizado-item';
import { CampoPersonalizado } from 'src/app/models/campo-personalizado';

@Component({
  selector: 'app-cadastro-opcao-tabela-personalizada-modal',
  templateUrl: './cadastro-opcao-tabela-personalizada-modal.component.html',
  styleUrls: ['./cadastro-opcao-tabela-personalizada-modal.component.scss']
})
export class CadastroOpcaoTabelaPersonalizadaModalComponent implements OnInit {
  opcao: CampoPersonalizadoItem;
  tabela: CampoPersonalizado;

  constructor(
    public dialogRef: MatDialogRef<CadastroOpcaoTabelaPersonalizadaModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit(): void {
    if(!!this.data && !!this.data.opcao) {
      this.opcao = this.data.opcao;
    } else {
      this.opcao = new CampoPersonalizadoItem();
      this.opcao.excluir = false;
    }

    if(!!this.data && !!this.data.tabela)
      this.tabela = this.data.tabela;
  }

  salvar() {
    this.dialogRef.close(this.opcao);
  }

  fechar() {
    this.dialogRef.close();
  }
}
